/* Country/currency menu: native Shopify localization form handles the switch. */
(() => {
  const menus = document.querySelectorAll('[data-nsc-localization]');
  if (!menus.length) return;
  for (const menu of menus) {
    const search = menu.querySelector('[data-nsc-country-search]');
    const options = Array.from(menu.querySelectorAll('[data-nsc-country-option]'));
    const groups = Array.from(menu.querySelectorAll('[data-nsc-country-group]'));
    const empty = menu.querySelector('[data-nsc-country-empty]');
    const form = menu.querySelector('.nsc-localization__form');
    const countryField = form?.querySelector('[data-nsc-country-input]');
    if (!search || !form || !countryField) continue;
    for (const option of options) {
      option.addEventListener('click', () => {
        const code = option.dataset.nscCountryCode;
        if (!code) return;
        countryField.value = code;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }
    search.addEventListener('input', () => {
      const q = search.value.trim().toLocaleLowerCase();
      let visible = 0;
      for (const option of options) {
        const match = !q || (option.dataset.search || '').includes(q);
        option.hidden = !match;
        if (match) visible++;
      }
      for (const group of groups) {
        let next = group.nextElementSibling;
        let hasVisible = false;
        while (next && !next.matches('[data-nsc-country-group]')) {
          if (next.matches('[data-nsc-country-option]') && !next.hidden) {hasVisible = true; break;}
          next = next.nextElementSibling;
        }
        group.hidden = !hasVisible;
      }
      if (empty) empty.hidden = visible !== 0;
    });
    menu.addEventListener('toggle', () => {
      if (!menu.open) {
        search.value = '';
        search.dispatchEvent(new Event('input'));
      } else {
        for (const other of menus) if (other !== menu) other.open = false;
      }
    });
    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) {
        menu.open = false;
        menu.querySelector('summary')?.focus();
        event.stopPropagation();
      }
    });
  }
  document.addEventListener('click', (event) => {
    for (const menu of menus) if (menu.open && !menu.contains(event.target)) menu.open = false;
  });
})();
